export default __webpack_public_path__ + "static/reishiS(1)-6992f48d53743a5637c7f7e2625dd668.webp";